<template>
  <div class="team">
    <div class="topTitle">
      <div style="overflow: hidden;">
        <div class="fl">
          <el-form ref="form" :model="form" :inline="true" size="mini">
            <el-form-item label="">
              <el-input
                style="width:200px;"
                v-model="form.name"
                placeholder="请输入团队名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="search">
                查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                icon="el-icon-plus"
                size="mini"
                @click="addTema"
                >新增团队</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="fr">
          <el-checkbox v-model="is_show_onw_team" @change="changeShow"
            >显示自己团队</el-checkbox
          >
        </div>
      </div>
    </div>
    <div class="main">
      <div slot="empty" v-if="teamList.length === 0">
        <div>
          <img
            style="position: absolute; top:40%;left: 50%;"
            src="https://steamfun-cdn.oss-cn-zhangjiakou.aliyuncs.com/resources/static/images/noteam.png"
            alt="暂无数据"
            width="250"
            height="250"
          />
        </div>
      </div>

      <ul class="clearfix">
        <li v-for="(item, index) in teamList" :key="index" class="clearfix">
          <el-card shadow="never">
            <div class="fl">
              <div
                class="teamTitle"
                style="cursor:pointer;"
                @click="goDetails(item)"
              >
                <svg
                  style="float:left"
                  t="1658391915897"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2354"
                  width="40"
                  height="40"
                >
                  <path
                    d="M0 512C0 229.248 229.248 0 512 0s512 229.248 512 512-229.248 512-512 512S0 794.752 0 512z"
                    fill="#5A91F7"
                    p-id="2355"
                  ></path>
                  <path
                    d="M751.872 638.3104c64.128-49.408 75.904-141.44 26.496-205.568a146.24 146.24 0 0 0-129.664-56.32c8.96 23.552 13.568 48.512 13.568 73.728 0 64.896-30.08 126.08-81.536 165.632 49.536 19.2 81.536 49.024 81.536 82.816 0 25.472-18.176 48.768-48.128 66.816 15.872 2.816 32 4.096 48.128 4.096 81.024 0 146.688-32.896 146.688-73.344-0.128-23.552-22.528-44.544-57.088-57.856"
                    fill="#D6E8FD"
                    p-id="2356"
                  ></path>
                  <path
                    d="M552.704 618.2144c91.648-70.784 108.544-202.368 37.76-293.888s-202.368-108.544-293.888-37.76-108.544 202.368-37.76 293.888c10.88 14.208 23.68 26.88 37.76 37.76-49.536 19.2-81.536 49.024-81.536 82.816 0 57.856 93.824 104.704 209.536 104.704s209.536-46.976 209.536-104.704c0.128-33.664-31.872-63.616-81.408-82.816"
                    fill="#FFFFFF"
                    p-id="2357"
                  ></path>
                  <path
                    d="M424.704 577.1264c-49.024 0-93.184-29.312-112.256-74.496-4.608-11.52 1.024-24.448 12.544-29.056 11.136-4.352 23.68 0.64 28.672 11.648a77.2608 77.2608 0 0 0 101.248 41.088c18.56-7.808 33.28-22.528 41.088-41.088 4.864-11.392 18.048-16.512 29.312-11.648 11.264 4.864 16.512 17.792 11.776 29.056a121.6896 121.6896 0 0 1-112.384 74.496"
                    fill="#5A91F7"
                    p-id="2358"
                  ></path>
                </svg>
                <span style="float:left;margin-left:20px;line-height:40px;">
                  {{ item.title }}</span
                >
              </div>
            </div>
            <div class="fr">
              <i class="el-icon-edit" @click="edit(item)"></i>
              <svg
                t="1658392277733"
                style="cursor:pointer;"
                @click="del(item)"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="3285"
                width="20"
                height="20"
              >
                <path
                  d="M30.117647 240.865233h963.460932v120.432617H30.117647z"
                  p-id="3286"
                ></path>
                <path
                  d="M768.188938 897.885373a34.74481 34.74481 0 0 0-14.0304 13.36802c-1.866706 3.010815-1.445191 1.204326-1.445192-8.008769v-2.047354c7.165741-0.843028 12.043262-1.926922 15.475592-3.311897zM752.713346 361.29785h120.432617V903.244624c0 133.078041-107.787192 120.432617-240.865233 120.432617H391.415497c-133.078041 0-240.865233 12.645425-240.865233-120.432617V361.29785h120.432616v539.89942c15.596024 1.866706 41.970767 2.589301 88.277108 2.228003L391.415497 903.244624h240.865233c9.273311 0 16.860566 0 32.155508 0.180649 46.306341 0.361298 72.681084-0.361298 88.277108-2.228003V361.29785zM270.98288 903.244624c0 9.213095 0.421514 11.079801-1.445191 8.008769a37.876058 37.876058 0 0 0-12.043262-12.344343c2.047354 0.48173 6.744227 1.505408 13.488453 2.28822V903.244624z m0 0c0 9.213095 0.421514 11.079801-1.445191 8.008769a34.74481 34.74481 0 0 0-14.0304-13.36802c3.43233 1.384975 8.309851 2.468869 15.475591 3.311897V903.244624z m88.277108 0.180649L391.415497 903.244624h240.865233c9.273311 0 16.860566 0 32.155508 0.180649 46.306341 0.361298 72.681084-0.361298 88.277108-2.228003V361.29785h120.432617V903.244624c0 133.078041-107.787192 120.432617-240.865233 120.432617H391.415497c-133.078041 0-240.865233 12.645425-240.865233-120.432617V361.29785h120.432616v539.89942c15.596024 1.866706 41.970767 2.589301 88.277108 2.228003z m408.26657-5.299035a38.418005 38.418005 0 0 0-13.36802 13.127155c-1.866706 3.010815-1.445191 1.204326-1.445192-8.008769v-2.047354c6.744227-0.782812 11.441099-1.806489 14.813212-3.010816z"
                  p-id="3287"
                ></path>
                <path
                  d="M331.199188 0h361.29785v120.432617H331.199188zM331.199188 481.730466h120.432617v301.081542H331.199188zM572.064421 481.730466h120.432617v301.081542H572.064421z"
                  p-id="3288"
                ></path>
              </svg>
            </div>
            <div class="clearfix teamItem" style="margin-top:60px;">
              <div class="fl" style="margin-left:10px;">
                成员数:<span style="margin-left:10px;">{{ item.stu_num }}</span>
              </div>
              <div class="fl" style="margin-left:10px;">
                总提交:<span style="margin-left:10px">{{
                  item.totalSubmissionNum
                }}</span>
              </div>
              <div class="fl" style="margin-left:10px;">
                创建人:<span style="margin-left:10px">{{ item.realname }}</span>
              </div>
            </div>
            <div
              class="teamItem"
              style="margin-left:10px;color: #808080; font-size: 14px;"
            >
              助教老师:
              <span v-if="item.assistant_user_str" style="margin-left:10px;">{{
                item.assistant_user_str
              }}</span>
              <span v-else>--</span>
            </div>
          </el-card>
        </li>
      </ul>

      <div
        class="fr"
        style=" text-align: right;padding:20px;"
        v-if="teamList.length > 0"
      >
        <el-pagination
          @current-change="handleCurrent"
          :current-page="page_no"
          :page-size="page_size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog title="新增团队" :visible.sync="dialogVisible" width="40%">
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="80px"
        :rules="rules"
        label-position="top"
      >
        <el-form-item label="团队名称" prop="title" required>
          <el-input
            v-model="addForm.title"
            placeholder="请输入团队名称"
            :maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="submit('addForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  tchAddOrUpdateOjTeam,
  tchGetOwnOjTeamList,
  tchDeleteOjTeam,
} from '@/api/educational.js'
export default {
  data() {
    return {
      is_show_onw_team1: 0,
      is_show_onw_team: false,
      page_no: 1,
      page_size: 20,
      total: 20,
      addForm: {
        title: '',
        notic: '',
      },
      dialogVisible: false,
      form: {
        name: '',
      },
      teamList: [],
      rules: {
        title: [
          {
            required: true,
            message: '请输入团队名称',
            trigger: 'change',
          },
          {
            required: true,
            message: '请输入标签名称',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.tchGetOwnOjTeamList()
  },
  methods: {
    search() {
      this.page_no = 1
      this.tchGetOwnOjTeamList()
    },
    changeShow() {
      // this. is_show_onw_team =
      if (this.is_show_onw_team == false) {
        this.is_show_onw_team1 = 0
      } else {
        this.is_show_onw_team1 = 1
      }
      this.page_no = 1
      this.tchGetOwnOjTeamList()
    },
    edit(item) {
      this.$prompt('请输入团队名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: item.title,
        inputPattern: /^.{1,20}$/,
        inputErrorMessage: '请输入1~20字之间的团队名称',
      })
        .then(({ value }) => {
          tchAddOrUpdateOjTeam({
            id: item.id,
            title: value,
            notic: item.notic,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '修改成功',
            })
            this.tchGetOwnOjTeamList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入',
          })
        })
    },
    del(item) {
      this.$confirm('是否确认删除该团队？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          tchDeleteOjTeam({
            id: item.id,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.tchGetOwnOjTeamList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    tchGetOwnOjTeamList() {
      tchGetOwnOjTeamList({
        is_show_onw_team: this.is_show_onw_team1,
        title_code: this.form.name,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res)
        this.teamList = res.ojTeamList
        this.total = res.total
      })
    },
    handleCurrent(val) {
      this.page_no = val
      this.tchGetOwnOjTeamList()
    },
    close() {
      this.$refs['addForm'].resetFields()
      this.dialogVisible = false
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          tchAddOrUpdateOjTeam({
            ...this.addForm,
          }).then(() => {
            this.$message.success('添加成功!')
            this.close()
            this.tchGetOwnOjTeamList()
          })
        }
      })
    },
    addTema() {
      this.dialogVisible = true
    },
    goDetails(item) {
      console.log(item, 5623)
      sessionStorage.setItem('notic', item.notic)
      this.$router.push({
        name: 'teamDetails',
        query: {
          team: JSON.stringify(item),
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.team {
  height: calc(100vh - 80px);
  background: white;
  margin: 10px;
  border-radius: 5px;
  overflow-y: scroll;
}

.topTitle {
  height: 60px;
  background: #fff;
  margin: 10px;
  margin-bottom: 0px;
  cursor: pointer;

  padding: 20px;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.main {
  min-height: calc(100vh - 200px);
  margin: 10px;
  margin-top: 0px;
  border-radius: 5px;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
  display: flex;
  align-items: center;
  height: 40px;
  .el-icon-edit {
    margin-right: 15px;
    font-size: 20px;
    cursor: pointer;
  }
}

.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
}

.bg {
  background: #fff;
  padding: 20px;
}

.main ul {
  width: 100%;
  box-sizing: border-box;
}

.main li {
  width: calc(50% - 5px);
  float: left;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 10px;
}

.main li:nth-of-type(2n) {
  margin-left: 10px;
}

.teamItem {
  margin-top: 20px;
}

.teamItem div {
  margin-right: 20px;
  font-size: 14px;
  color: rgba(128, 128, 128, 1);
}

.teamTitle {
  color: rgba(56, 56, 56, 1);
  font-size: 16px;
  font-weight: bold;
}

/deep/.el-card {
  padding: 20px !important;
}

/deep/.el-dialog {
  border-radius: 10px !important;
}
</style>
